import NodesClassifier from "./Auxiliar/NodesClassifier";

export default class ActiveDataManager {
    // Public:
    constructor(cParams) {
        this.saveParams(cParams);
        this.initActiveData();
        this.computeAllIndices();
        this.initActiveIndices();
    }

    compute(indices) {
        this.saveActiveIndices(indices);
        this.setActiveNodes();
        this.setActiveLinks();
        this.updateDependencies();
        this.removeExtraNodes();
        this.setActiveNodes();
        this.setActiveLinks();
        this.updateDependencies();
    }

    updateChart() {
        this.setActiveData();
        this._chart.computeClustering();
        this._chart.refresh();
    }

    setActiveData() {
        let chart = this._chart;
        chart._activeNodes = this._activeNodes;
        chart._activeLinks = this._activeLinks;
    }

    //Private:
    saveParams(cParams) {
        this._inputNodes = cParams.inputNodes;
        this._inputLinks = cParams.inputLinks;
        this._maxSoloNodesPerSpeaker = cParams.maxNodesPerSpeaker;
        this._chart = cParams.chart;
    }

    initActiveData() {
        this.initActiveNodes();
        this.initActiveLinks();
    }

    initActiveNodes() {
        const inputNodes = this._inputNodes;
        const clonedNodes = this.cloneArray(inputNodes);
        this._activeNodes = clonedNodes;
    }

    initActiveLinks() {
        const inputLinks = this._inputLinks;
        const clonedLinks = this.cloneArray(inputLinks);
        this._activeLinks = clonedLinks;
    }

    saveActiveIndices(indices) {
        const indicesExists = indices !== undefined;
        if (indicesExists) this._activeNodeIndices = indices;
        else this.initActiveIndices();
    }

    removeExtraNodes() {
        let masterNodes = this.getMasterNodes();
        masterNodes.forEach(node => {
            const soloNodes = node.soloNodes;
            const lighterNodes = this.getLighterNodes(soloNodes);
            this.removeNodesIndices(lighterNodes);
        });
    }

    setActiveNodes() {
        let activeNodes = [];
        let nodes = this._inputNodes;
        let indices = this._activeNodeIndices;
        indices.forEach(index => {
            const node = nodes[index];
            activeNodes.push(node);
        });
        this._activeNodes = activeNodes;
    }

    setActiveLinks() {
        let activeLinks = [];
        let links = this._inputLinks;
        links.forEach(link => {
            const sourceIndex = link.source.number;
            const targetIndex = link.target.number;
            const isSourceActive = this.isNodeActive(sourceIndex);
            const isTargetActive = this.isNodeActive(targetIndex);
            if (isSourceActive && isTargetActive) activeLinks.push(link);
        });
        this._activeLinks = activeLinks;
    }

    updateDependencies() {
        let cParams = {
            nodes: this._activeNodes,
            links: this._activeLinks,
        };
        let classifier = new NodesClassifier(cParams);
        classifier.compute();
    }

    isNodeActive(index) {
        const indices = this._activeNodeIndices;
        const isIndexInActiveList = indices.indexOf(index) !== -1;
        if (isIndexInActiveList) return true;
        else return false;
    }

    computeAllIndices() {
        let indices = [];
        const nodes = this._inputNodes;
        for (let i = 0; i < nodes.length; i++) {
            indices.push(i);
        }
        this._allIndices = indices;
    }

    initActiveIndices() {
        this._activeNodeIndices = this._allIndices;
    }

    getMasterNodes() {
        let nodeList = [];
        const nodes = this._inputNodes;
        for (let i = 0; i < nodes.length; i++) {
            const node = nodes[i];
            const itIsMaster = node.type === "master";
            if (itIsMaster) nodeList.push(node);
        }
        return nodeList;
    }

    getLighterNodes(nodes) {
        let lighterIndices = [];
        const maxNodes = this._maxSoloNodesPerSpeaker;
        let weightList = this.getWeightList(nodes);
        const sortedWeights = weightList.sortNumbers();
        const lighterWeights = this.getTopElements(sortedWeights, maxNodes);
        lighterWeights.forEach(weight => {
            const index = weightList.indexOf(weight);
            const node = nodes[index];
            weightList[index] = undefined;
            lighterIndices.push(node.number);
        });
        return lighterIndices;
    }

    removeNodesIndices(indices) {
        indices.forEach(index => {
            const i = this._activeNodeIndices.indexOf(index);
            this._activeNodeIndices.splice(i, 1);
        });
    }

    getWeightList(nodes) {
        let weights = [];
        for (let i = 0; i < nodes.length; i++) {
            const node = nodes[i];
            const weight = node.weight || 0;
            weights.push(weight);
        }
        return weights;
    }

    getTopElements(array, N) {
        for (let i = 0; i < N; i++) {
            array.pop();
        }
        return array;
    }

    cloneArray(array) {
        let clonedArray = [];
        array.forEach(element => {
            clonedArray.push(element);
        });
        return clonedArray;
    }
}
